module.exports = __webpack_public_path__ + "static/media/ho.34f1e4db.png";